<template>
  <group :config="{...config, draggable: false, isStatic}">
    <v-arc 
      :config="{
        ...elementConfig,
        innerRadius: parseInt(innerRadius),
        angle: parseInt(angle),
        rotationDeg: parseInt(rotationDegrees),
        fill: color,
      }"
    />
  </group>
</template>

<script>
import canvasElement from './mixins/canvasElement'
import withLabel from './mixins/withLabel'
import Group from './Group'
export default {
  name: 'DrawArc',
  components: {Group},
  mixins: [canvasElement, withLabel],
  props: {
    angle: {
      validator (value) {return !isNaN(value)},
      required: true
    },
    innerRadius: {
      validator (value) {return !isNaN(value)},
      required: true
    },
    rotationDegrees: {
      validator (value) {return !isNaN(value)},
      default: 0
    },
    color: {
      type: String,
      default: 'black'
    }
  },
  data () {
    return {}
  },
  computed: {
    isStatic () {return true}
  }
}
</script>